"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerSettingsSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const constants_1 = require("../../constants");
exports.CustomerSettingsSchema = joi_1.default.object({
    organizationUuid: joi_1.default.string().required(),
    theme: joi_1.default.string().required(),
    settings: joi_1.default.object({
        bookingUI: joi_1.default.object({
            banner: joi_1.default.string(),
            externalIdRequired: joi_1.default.boolean()
        }),
        emails: joi_1.default.object({
            sentOnBehalf: joi_1.default.string(),
            contactUsEmail: joi_1.default.string().email({ tlds: { allow: !constants_1.isBrowser } }),
            hideRescheduling: joi_1.default.boolean()
        }),
        intl: joi_1.default.object()
    }).required()
}).meta({ className: 'CustomerSettings' });
//# sourceMappingURL=CustomerSettingsSchema.js.map